export const BACKEND_CONFIG = {
  apiUrl: process.env.REACT_APP_BASE_URL,
  set: (key, value) => {
    if (value) {
      localStorage.setItem(key, value);
    }
  },
  get: key => localStorage.getItem(key),
  remove: key => localStorage.removeItem(key),
};

export const REGISTRATION_URL = '/login';
export const LOGIN_URL = 'account/login';
export const RESET_PASSWORD_URL = 'account/reset-password';
